import { combineReducers } from 'redux';
import defaultLayout from '../../default/reducers';

export default combineReducers({
  defaultLayout
});
